// KU – use feature detection to determine if touch device
// https://stackoverflow.com/a/63666289

export const isBrowser = () => typeof window !== 'undefined';

export const isTouchDevice = () =>
  window.matchMedia('(hover:none)').matches || 'ontouchstart' in window;
